<template>
  <el-card>
    <!-- /* ---------------------------------- 搜索表单 ---------------------------------- */ -->
    <el-row>
      <el-form :model="form" v-bind="formProps.form" :rules="{}">
        <!-- <el-form-item prop="formTime" :label="$t('orders.label.form.submitTime')">
          <v-date-picker ref="datePick" v-model="formTime" />
        </el-form-item> -->
        <el-form-item :label="$t('channel.label.accountNumber')" prop="accountNumber">
          <el-input v-model="form.accountNumber" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.recipientName')" prop="recipientName">
          <el-input v-model="form.recipientName" />
        </el-form-item>

        <el-form-item v-if="channelCodeList" :label="$t('channel.label.channelCode')" prop="channelCode">
          <el-select v-model="form.channelCode">
            <el-option v-for="item in channelCodeList" :key="item" :value="item"> </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('channel.label.status')" prop="status">
          <el-select v-model="form.status">
            <el-option v-for="item in this.statusData" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="warning" @click="handleEmpty()">{{
            $t('btns.empty')
            }}</el-button>
          <el-button size="mini" type="primary" @click="handleSearch()">{{
            $t('btns.search')
            }}</el-button>
          <el-button size="mini" type="primary" @click="handleOpen()">{{
            $t('btns.add')
            }}</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <!-- /* ---------------------------------- 表格数据 ---------------------------------- */ -->
    <el-row>
      <div class="header-table">
        <ul class="list-table">
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('channel.label.todayTotal') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.todayTotal | toThousands }}
            </span>
          </li>
          <li class="li-table">
            <em class="label">
              <span>
                {{ $t('channel.label.yestodayTotal') }}
              </span>
              <span>：</span>
            </em>
            <span class="value">
              {{ totalData.yestodayTotal | toThousands }}
            </span>
          </li>
        </ul>
      </div>
      <el-table :data="tableList" :row-style="tableRowStyle" :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column width="280px" align="center" :label="$t('channel.label.action')">
          <template slot-scope="{ row }">
            <el-popconfirm :ref="`popover-${row.id}-1`" :key="`${row.id}-1`" :title="$t('orders.tip.danger')"
              @confirm="handleOpen(row)">
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('btns.editor') }}
              </el-button>
            </el-popconfirm>

            <el-popconfirm :ref="`popover-${row.id}-2`" :key="`${row.id}-2`" v-if="row.status === 0"
              :title="$t('orders.tip.danger')" @confirm="handleStatus(row, 1)">
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('btns.stop') }}
              </el-button>
            </el-popconfirm>
            <el-popconfirm :ref="`popover-${row.id}-3`" :key="`${row.id}-3`" v-else :title="$t('orders.tip.danger')"
              @confirm="handleStatus(row, 0)">
              <el-button slot="reference" type="primary" size="mini">
                {{ $t('btns.start') }}
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
        <!-- <el-table-column
          width="120px"
          prop="channelCode"
          align="center"
          :label="$t('channel.label.channelCode')"
        />

        <el-table-column
          width="120px"
          prop="recipientId"
          align="center"
          :label="$t('channel.label.recipientId')"
        /> -->
        <el-table-column prop="recipientName" align="center" :label="$t('channel.label.recipientName')" />

        <el-table-column width="120px" prop="updateAcct" align="center" :label="$t('channel.label.updateAcct')" />
        <el-table-column width="120px" prop="accountName" align="center" :label="$t('channel.label.accountName')" />
        <el-table-column width="120px" prop="accountNumber" align="center" :label="$t('channel.label.accountNumber')" />

        <el-table-column width="120px" prop="channelType" align="center" :label="$t('channel.label.channelType')" />
        <el-table-column width="120px" prop="dayQuota" align="center" :label="$t('channel.label.dayQuota')">
          <template slot-scope="{ row }">
            {{ row.dayQuota | toThousands }}
          </template>
        </el-table-column>
        <el-table-column width="120px" prop="monthQuota" align="center" :label="$t('channel.label.monthQuota')">
          <template slot-scope="{ row }">
            {{ row.monthQuota | toThousands }}
          </template>
        </el-table-column>

        <el-table-column width="220px" prop="id" align="center" :label="$t('channel.label.id')" />

        <el-table-column prop="status" align="center" :label="$t('channel.label.status')">
          <template slot-scope="{ row }">
            <p>
              <el-tag v-for="item in statusData" :key="item.label" :type="item.type" v-show="item.value === row.status">
                {{ item.label }}
              </el-tag>
            </p>
          </template>
        </el-table-column>

        <el-table-column width="120px" prop="todayTotal" align="center" :label="$t('channel.label.todayTotal')">
          <template slot-scope="{ row }">
            {{ row.todayTotal | toThousands }}
          </template>
        </el-table-column>
        <el-table-column width="120px" prop="yestodayTotal" align="center" :label="$t('channel.label.yestodayTotal')">
          <template slot-scope="{ row }">
            <span v-if="row.history.length > 1">
              {{ row.history[1].total | toThousands }}
            </span>
          </template>
        </el-table-column>

        <el-table-column width="220px" prop="updateTime" align="center" :label="$t('channel.label.updateTime')">
          <template slot-scope="{ row }">
            {{ row.updateTime | asDayjs }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- /* ----------------------------------- 分页 ----------------------------------- */ -->
    <v-pagination v-model="pagination" :total="tableData.count" @update="getTableData" />

    <!-- /* ---------------------------------- 编辑弹窗 ---------------------------------- */ -->
    <el-dialog :title="$t(`channel.titles.${isAdd ? 'add1' : 'editor1'}`)" :visible.sync="dialogVisible" width="30%">
      <el-form :model="form1" v-bind="formProps.form1" :inline="false">
        <el-form-item :label="$t('channel.label.accountNumber')" prop="accountNumber">
          <el-input v-model="form1.accountNumber" />
        </el-form-item>

        <el-form-item :label="$t('channel.label.channelType')" prop="channelType">
          <el-select v-model="form1.channelType" :disabled="true">
            <el-option v-for="item in channelTypeList" :key="item" :value="item"> </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="channelCodeList" :label="$t('channel.label.channelCode')" prop="channelCode">
          <el-select v-model="form1.channelCode" :disabled="true">
            <el-option v-for="item in channelCodeList" :key="item" :value="item"> </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item :label="$t('channel.label.accountName')" prop="accountName">
          <el-input v-model="form1.accountName" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.accountId1')" prop="accountId">
          <el-input v-model="form1.accountId" />
        </el-form-item>
        <!-- <el-form-item :label="$t('channel.label.recipientCode')" prop="recipientCode">
          <el-input v-model="form1.recipientCode" />
        </el-form-item> -->

        <!-- <el-form-item :label="$t('channel.label.recipientId')" prop="recipientId">
          <el-input v-model="form1.recipientId" />
        </el-form-item> -->
        <el-form-item :label="$t('channel.label.recipientName')" prop="recipientName">
          <el-input v-model="form1.recipientName" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.dayQuota')" prop="dayQuota">
          <el-input v-model="form1.dayQuota" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.monthQuota')" prop="monthQuota">
          <el-input v-model="form1.monthQuota" />
        </el-form-item>
        <el-form-item :label="$t('channel.label.singleMaxLimit')" prop="singleMaxLimit">
          <el-input v-model="form1.singleMaxLimit" />
        </el-form-item>

        <el-form-item :label="$t('channel.label.singleMinLimit')" prop="singleMinLimit">
          <el-input v-model="form1.singleMinLimit" />
        </el-form-item>

        <el-form-item :label="$t('channel.label.status')" prop="status">
          <el-select v-model="form1.status">
            <el-option v-for="item in this.statusData" :key="item.label" :label="item.label" :value="item.value">
            </el-option>
            <el-option :label="$t('btns.emptyValue')" value=""></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="warning" @click="handleEmpty()">{{
            $t('btns.empty')
            }}</el-button>
          <el-button size="mini" @click="dialogVisible = false">{{ $t('btns.cancel') }}</el-button>
          <el-button size="mini" type="primary" @click="handleEditor()">{{
            $t('btns.confirm')
            }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
  import { debounce } from 'lodash';
  import channelApi from '@/api/channel';
  import { isNumber, validEmail } from '@/utils/validate';
  export default {
    name: 'channelUserMomo',
    data() {
      return {
        isAdd: true,
        dialogVisible: false,

        /* ---------------------------------- 搜索表单 ---------------------------------- */
        formTime: [],
        form: {
          accountNumber: '',
          channelType: 'momo_qr',
          status: '',
          recipientName: ''
        },

        /* ---------------------------------- 编辑表单 ---------------------------------- */
        form1: {},
        pagination: {
          no: 1,
          size: this.$defaultPaginationSize
        },

        channelTypeData: {},
        tableData: {}
      };
    },
    computed: {
      tableList() {
        return this.tableData.list || [];
      },
      totalData() {
        return this.tableData.list
          ? this.tableData.list.reduce((acc, curr, index) => {
            const t = curr.todayTotal;
            const y = curr.history[1].total;
            acc = {
              todayTotal: acc.todayTotal ? acc.todayTotal + Number(t) : Number(t),
              yestodayTotal: acc.yestodayTotal ? acc.yestodayTotal + Number(y) : Number(y)
            };
            return acc;
          }, {})
          : {};
      },
      channelTypeList() {
        return Object.keys(this.channelTypeData) || [];
      },
      channelCodeList() {
        if (Array.isArray(this.channelTypeData[this.form1.channelType])) {
          return this.channelTypeData[this.form1.channelType].length > 0
            ? this.channelTypeData[this.form1.channelType]
            : '';
        } else {
          return '';
        }
      },
      statusData() {
        return [
          {
            label: this.$t('status.success2'),
            type: 'success',
            value: 0
          },
          {
            label: this.$t('status.error2'),
            type: 'error',
            value: 1
          }
        ];
      }
    },
    created() {
      this.init();
    },
    mounted() {
      this.getTableData();
      this.getConfType();
    },
    methods: {
      init() {
        this.handleSearch = debounce(this._handleSearch, 300);
        this.handleEditor = debounce(this._handleEditor, 300);
        this.handleEmpty1();
        /* ----------------------------- element -props ----------------------------- */
        this.formProps = {
          form: {
            ref: 'form',
            'label-width': 'auto',
            inline: true,
            size: 'small',
            rules: {
              channelType: [
                {
                  required: true,
                  message: this.$t('channel.rules.channelType'),
                  trigger: 'blur'
                }
              ],
              channelCode: [
                {
                  required: true,
                  message: this.$t('channel.rules.channelCode'),
                  trigger: 'blur'
                }
              ]
            }
          },
          form1: {
            ref: 'form',
            'label-width': 'auto',
            inline: true,
            size: 'small',
            rules: {
              accountId: [
                {
                  required: true,
                  message: this.$t('channel.rules.accountId.empty'),
                  trigger: 'blur'
                },
                {
                  validator: (rule, value, cb) => {
                    if (!validEmail(value)) {
                      cb(new Error(this.$t('channel.rules.accountId.type')));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
              ],

              accountNumber: [
                {
                  required: true,
                  message: this.$t('channel.rules.accountNumber.empty'),
                  trigger: 'blur'
                },
                {
                  validator: (rule, value, cb) => {
                    if (!isNumber(value)) {
                      cb(new Error(this.$t('channel.rules.accountNumber.type')));
                    } else if (String(value).length < 7) {
                      cb(new Error(this.$t('channel.rules.accountNumber.min')));
                    } else if (String(value).length >= 32) {
                      cb(new Error(this.$t('channel.rules.accountNumber.max')));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
              ],
              dayQuota: [
                {
                  required: true,
                  message: this.$t('channel.rules.dayQuota.empty'),
                  trigger: 'blur'
                },
                {
                  validator: (rule, value, cb) => {
                    if (!isNumber(value)) {
                      cb(new Error(this.$t('channel.rules.dayQuota.type')));
                    } else if (Number(value) <= 0) {
                      cb(new Error(this.$t('channel.rules.dayQuota.match')));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
              ],
              monthQuota: [
                {
                  required: true,
                  message: this.$t('channel.rules.monthQuota.empty'),
                  trigger: 'blur'
                },
                {
                  validator: (rule, value, cb) => {
                    if (!isNumber(value)) {
                      cb(new Error(this.$t('channel.rules.monthQuota.type')));
                    } else if (Number(value) <= Number(this.form1.dayQuota)) {
                      cb(new Error(this.$t('channel.rules.monthQuota.match')));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
              ],
              singleMaxLimit: [
                {
                  required: true,
                  message: this.$t('channel.rules.singleMaxLimit.empty'),
                  trigger: 'blur'
                },
                {
                  validator: (rule, value, cb) => {
                    if (!isNumber(value)) {
                      cb(new Error(this.$t('channel.rules.singleMaxLimit.type')));
                    } else if (Number(value) < 0) {
                      cb(new Error(this.$t('channel.rules.singleMaxLimit.match')));
                    } else if (Number(value) < Number(this.form1.singleMinLimit)) {
                      cb(new Error(this.$t('channel.rules.singleMaxLimit.match1')));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
              ],
              singleMinLimit: [
                {
                  required: true,
                  message: this.$t('channel.rules.singleMinLimit.empty'),
                  trigger: 'blur'
                },
                {
                  validator: (rule, value, cb) => {
                    if (!isNumber(value)) {
                      cb(new Error(this.$t('channel.rules.singleMinLimit.type')));
                    } else if (Number(value) < 0) {
                      cb(new Error(this.$t('channel.rules.singleMinLimit.match')));
                    } else {
                      cb();
                    }
                  },
                  trigger: 'blur'
                }
              ],
              accountName: [
                {
                  required: true,
                  message: this.$t('channel.rules.accountName.empty'),
                  trigger: 'blur'
                }
              ],
              channelType: [
                {
                  required: true,
                  message: this.$t('channel.rules.channelType'),
                  trigger: 'blur'
                }
              ],
              channelCode: [
                {
                  required: true,
                  message: this.$t('channel.rules.channelCode'),
                  trigger: 'blur'
                }
              ]
            }
          }
        };
      },
      tableRowStyle({ row, index }) {
        if (Number(row.todayTotal) + Number(row.singleMinLimit) >= Number(row.dayQuota)) {
          return {
            backgroundColor: 'red'
          };
        }
      },
      /* ---------------------------------- 格式化数据 --------------------------------- */
      formatParams() {
        // const [transactionBeginTime, transactionEndTime] = this.formTime;
        // if (!transactionBeginTime || !transactionEndTime) {
        //   // 若用户点击了时间表单的清空，则重新默认选择当天数据
        //   this.$refs.datePick.handleTime('today');
        // }
        return {
          ...Object.keys(this.form).reduce(
            (acc, key) => {
              if (this.form[key] === 0 || this.form[key]) {
                acc[key] = this.form[key];
              }
              return acc;
            },
            {
              channels: ['momo_qr']
            }
          )
          // transactionBeginTime: transactionBeginTime,
          // transactionEndTime: transactionEndTime
        };
      },
      /* --------------------------------- 获取分页数据 --------------------------------- */
      async getTableData() {
        const { data } = await channelApi.getPage({
          data: {
            query: this.formatParams(),
            no: this.pagination.no,
            size: this.pagination.size
          }
        });
        if (data && data.code == 200) {
          this.tableData = data.data;
        }
      },
      async getConfType() {
        const { data } = await channelApi.confType();
        if (data && data.code == 200) {
          this.channelTypeData = data.data;
        } else {
          this.$message.error(data.message);
        }
      },

      /* --------------------------------- 事件驱动函数 --------------------------------- */
      handleEmpty() {
        this.form = {
          accountNumber: '',
          channelType: 'momo_qr',
          status: '',
          channels: ['momo_qr'],
          recipientName: ''
        };
      },
      handleEmpty1() {
        this.form1 = {
          accountNumber: '',
          channelType: 'momo_qr',
          channelCode: '',
          dayQuota: '',
          monthQuota: '',
          singleMaxLimit: '',
          accountName: '',
          accountId: '',
          recipientCode: '',
          recipientId: '',
          recipientName: '',

          singleMinLimit: '',
          status: '',
          channels: ['momo_qr']
        };
      },
      handleOpen(row) {
        this.dialogVisible = true;
        if (row) {
          this.isAdd = false;
          Object.keys(this.form1).forEach((key) => {
            if (row[key] === 0 || row[key]) {
              this.form1[key] = row[key];
            }
          });
          this.form1.id = row.id;
        }
      },
      handleStatus(row, status = 0) {
        // 0 为开启，1为关闭
        Object.keys(this.form1).forEach((key) => {
          if (row[key] === 0 || row[key]) {
            this.form1[key] = row[key];
          }
        });
        this.form1.status = status;
        this.form1.id = row.id;

        this.doUserUpdate();
      },
      async doUserAdd() {
        const params = {
          ...this.form1
        };
        const { data } = await channelApi.userAdd(params);
        if (data.success) {
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(data.message);
        }
      },
      async doUserUpdate() {
        const params = {
          ...this.form1
        };
        const { data } = await channelApi.userUpdate(params);
        if (data.success) {
          this.dialogVisible = false;
          this.getTableData();
        } else {
          this.$message.error(data.message);
        }
      },
      _handleEditor() {
        this.$refs.form.validate(
          (valid) => valid && this[this.isAdd ? 'doUserAdd' : 'doUserUpdate']()
        );
      },
      _handleSearch() {
        this.$refs.form.validate(async (valid) => valid && this.getTableData());
      }
    }
  };
</script>

<style lang="scss" scoped>
  .header-table {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgba(0, 0, 0, 0.2);
    padding-right: 40px;

    .list-table {
      display: flex;
      list-style: none;

      li {
        display: flex;
        list-style: none;

        .label {
          font-style: normal;
        }

        .value {
          display: flex;
          list-style: none;
        }
      }

      li:nth-child(n + 2) {
        margin-left: 30px;
      }
    }

    .btn-table {
      margin-left: auto;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/channel-user-momo/index.vue